import { CrudPage } from '@restavo/crud';
import React from 'react';
import { transactionCategoriesPage } from 'src/features/transactionCategories';

const TransactionCategories = React.memo(() => <CrudPage {...transactionCategoriesPage} />);

export default TransactionCategories;
